function getPrimaryRorName(item) {
  const names = item.names || [];
  const rorDisplay = names.find((name) => name.types?.includes("ror_display"));
  if (rorDisplay?.value) {
    return rorDisplay.value;
  }

  const label = names.find((name) => name.types?.includes("label"));
  if (label?.value) {
    return label.value;
  }

  const english = names.find((name) => name.lang === "en");
  if (english?.value) {
    return english.value;
  }

  const nonAcronym = names.find((name) => !name.types?.includes("acronym"));
  if (nonAcronym?.value) {
    return nonAcronym.value;
  }

  return names[0]?.value || item.id;
}

function mapRorOrganization(item) {
  const primaryName = getPrimaryRorName(item);

  const location = item.locations?.[0]?.geonames_details;
  const aliases =
    item.names
      ?.filter(
        (name) =>
          name.types?.includes("alias") || name.types?.includes("acronym")
      )
      .map((name) => name.value) || [];

  return {
    ror_id: item.id,
    ror_name: primaryName,
    country: location?.country_name,
    city: location?.name,
    aliases,
  };
}

export async function searchRorOrganizations(query, limit) {
  const response = await fetch(
    `https://api.ror.org/v2/organizations?query=${encodeURIComponent(query)}`
  );

  if (!response.ok) {
    throw new Error(`ROR API responded with status: ${response.status}`);
  }

  const data = await response.json();
  const results = (data.items || []).map(mapRorOrganization);

  return limit ? results.slice(0, limit) : results;
}

export function getGoogleSearchUrl(query) {
  return `https://www.google.com/search?q=${encodeURIComponent(query)}`;
}
